import script from "./FolderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FolderPage.vue?vue&type=script&setup=true&lang=js"

import "./FolderPage.vue?vue&type=style&index=0&id=79d780ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d780ba"]])

export default __exports__